import React from 'react';
import { Flex, Heading, IconFaceUnhappy, Paragraph, TextButton } from '@zillow/constellation';
import { useWizard, WizardSubStep } from '@zillow/zrs-rental-applications';
import { RENTER_CANNOT_IDV_HELP_URL } from '../../../constants/urls';
import { useTermSet } from '../../../contexts/IdVerificationContext';
import { IdvStep, TermSet } from '../../../../../models';

interface UserNotFoundProps {
  id: string;
}

function LandlordContent() {
  return (
    <Flex display="flex" flexDirection="column" gap="sm">
      <IconFaceUnhappy size="md" fontColor="blue600" />
      <Heading level={4} as="h2">
        Your identity couldn’t be verified
      </Heading>
      <Paragraph>
        We couldn’t verify your identity with the information provided. Until you’re verified, you won’t be able to
        access your applicant’s information, including credit check and background report.
      </Paragraph>
      <Paragraph>
        You can try again to get verified. When you enter your information, check that everything is correct, including
        your legal name, address, phone number, and Social Security number (if provided).
      </Paragraph>
    </Flex>
  );
}

function RenterContent() {
  return (
    <Flex display="flex" flexDirection="column" gap="sm" alignItems="flex-start">
      <IconFaceUnhappy size="md" fontColor="blue600" />
      <Heading level={4} as="h2">
        Couldn’t verify your identity
      </Heading>
      <Paragraph>
        You can submit your identity verification again. Check that all information is correct, including your legal
        name, address, and Social Security number.
      </Paragraph>
      <TextButton as="a" href={RENTER_CANNOT_IDV_HELP_URL} target="_blank">
        Learn more
      </TextButton>
    </Flex>
  );
}

export default function UserNotFound({ id }: UserNotFoundProps) {
  const { currentSubStep, onRequestStep } = useWizard();
  const termSet = useTermSet();
  return (
    <WizardSubStep
      id={id}
      hidden={currentSubStep !== id}
      meta={{
        renderNextButton: 'Retry',
        renderBackButton: () => null,
      }}
      onRequestNext={(abortController: AbortController) => {
        abortController.abort();
        onRequestStep(IdvStep.PersonalInfoStep);
      }}
      render={termSet === TermSet.LandlordScreening ? LandlordContent : RenterContent}
    />
  );
}
